/**
 * Os cookies do pixel do Meta que vão no cadastro, para a API de Conversões.
 *
 * O `telegram-bot` manda ao Meta os marcos do funil do criador (comunidade criada, primeira venda)
 * pelo servidor. Para o Meta casar essa conversão com quem viu o anúncio, os identificadores de
 * maior peso são estes dois, e eles só existem no navegador:
 *
 * - `_fbp`: gravado pelo pixel em toda visita. É o único que existe mesmo sem clique em anúncio.
 * - `_fbc`: gravado pelo pixel quando a URL traz `fbclid`, com o instante do CLIQUE. Sem ele o
 *   servidor reconstrói um a partir do `fbclid` guardado, mas com o instante do cadastro.
 *
 * Ausência é o caso comum, não erro: bloqueador de anúncio, pixel ainda não carregado, navegador
 * que recusa cookie. Nada aqui pode derrubar o cadastro.
 */

/** Espelha o `varchar(512)` das colunas `fbp`/`fbc` (changeset 648). */
const MAX = 512;

/** `fb.<subdomínio>.<ms>.<valor>` — o formato que o pixel grava e que a API aceita. */
const FORMATO = /^fb\.\d\.\d+\.\S+$/;

export type MetaBrowserSignals = { fbp?: string; fbc?: string };

const lerCookie = (cookies: string, nome: string) => {
  const par = cookies
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${nome}=`));
  if (!par) return undefined;

  try {
    const valor = decodeURIComponent(par.slice(nome.length + 1)).trim();
    return FORMATO.test(valor) ? valor.slice(0, MAX) : undefined;
  } catch {
    return undefined;
  }
};

/**
 * Os cookies `_fbp`/`_fbc` presentes e bem formados. Objeto vazio quando não há nenhum.
 *
 * Nunca lança: é lido dentro do `try` do envio do cadastro, que reporta "erro ao criar o cadastro".
 */
export const getMetaBrowserSignals = (
  cookies: string = typeof document === 'undefined' ? '' : document.cookie,
): MetaBrowserSignals => {
  try {
    const sinais: MetaBrowserSignals = {};
    const fbp = lerCookie(cookies, '_fbp');
    const fbc = lerCookie(cookies, '_fbc');
    if (fbp) sinais.fbp = fbp;
    if (fbc) sinais.fbc = fbc;

    return sinais;
  } catch {
    return {};
  }
};
